module.exports = __webpack_public_path__ + "static/img/gzh.37f874b9.jpg";